import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useEffect } from 'react';
import { Outlet } from 'react-router-dom';
import { BottomNav } from './BottomNav';
import { CreateBeaconSheet } from '../beacon/CreateBeaconSheet';
import { useAppDispatch } from '../../store/hooks';
import { fetchMeetings } from '../../store/slices/meetingsSlice';
export function TabLayout() {
    const dispatch = useAppDispatch();
    useEffect(() => {
        dispatch(fetchMeetings());
    }, [dispatch]);
    return (_jsxs("div", { className: "flex flex-col h-full", children: [_jsx("div", { className: "flex-1 min-h-0 overflow-hidden relative", children: _jsx(Outlet, {}) }), _jsx(BottomNav, {}), _jsx(CreateBeaconSheet, {})] }));
}
